import React, { Component } from "react";
import clx from "classnames";
import { withRouter } from "react-router";
import { compose } from "recompose";
import { withTranslation } from "react-i18next";
import Select from "react-select";

import { Button, SettingsIcon, Loader } from "../../common/index";
import { ReactComponent as MeteoLogo } from "../../../assets/tools/yourWeather/meteo.svg";

import WeatherConditions from "./WeatherConditions/WeatherConditions";
import Property from "./Property";
import "./styles.scss";

class WeatherModalInner extends Component {
  state = {
    selectedProperty: null,
    forecastLoaded: false,
    selectedOption: null,
    selectedDay: null,
  };

  componentDidMount() {
    const { forecast, initialSelected } = this.props;

    if (forecast.length > 0) {
      this.setState({
        forecastLoaded: true,
        selectedOption: {
          ...forecast[0],
          value: forecast[0].id,
          label: forecast[0].name,
        },
        selectedDay: initialSelected ? initialSelected.date : null,
        selectedProperty: initialSelected ? initialSelected.name : null,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { forecast } = this.props;
    if (prevProps.forecast.length === 0 && forecast.length > 0) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedOption: {
          ...forecast[0],
          value: forecast[0].id,
          label: forecast[0].name,
        },
      });
    }
  }

  render() {
    const {
      selectedProperty,
      forecastLoaded,
      selectedOption,
      selectedDay,
    } = this.state;
    const { history, forecast, t } = this.props;

    const selectOptions = forecast.map(cast => ({
      ...cast,
      value: cast.id,
      label: cast.name,
    }));

    return (
      <div className="weather-widget">
        <div className="weather-widget__heading">
          <div className="weather-widget__heading__text">
            {t("tools:weather.title")}
            {!forecastLoaded && <Loader absolute />}
          </div>
          <div className="weather-widget__heading__actions">
            {selectOptions.length > 1 ? (
              <div>
                <Select
                  className="weather-widget__select__wrapper"
                  classNamePrefix="weather-widget__select"
                  defaultValue={selectOptions[0]}
                  value={selectedOption}
                  inputId="weather-widget__property"
                  options={selectOptions}
                  onChange={value => {
                    this.setState({
                      selectedOption: value,
                      selectedProperty:
                        selectedProperty !== null ? value.name : null,
                    });
                  }}
                />
              </div>
            ) : (
              <div className="weather-widget_single">
                {!!selectOptions.length && selectOptions[0].label}
              </div>
            )}
            <Button
              buttonsize="small"
              buttoncolor="yellow"
              onClick={() => history.push("/my/farm")}
            >
              <SettingsIcon fillColor="" textColor="black" />
              <span>{t("globals:buttons.settings")}</span>
            </Button>
          </div>
        </div>
        {/* {this.state.selectedDay} */}
        <main
          className={clx({
            "weather-widget__propertyBox": selectedProperty,
            "weather-widget__weatherConditions":
              !selectedProperty && forecastLoaded && !!forecast.length,
          })}
        >
          {selectedProperty ? (
            <Property
              data={forecast
                .slice(0, 5)
                .find(property => property.name === selectedProperty)}
              selectedDay={this.state.selectedDay}
              onBack={() =>
                this.setState({
                  selectedDay: null,
                  selectedProperty: null,
                })
              }
            />
          ) : (
            selectedOption !== null && (
              <WeatherConditions
                property={forecast
                  .slice(0, 5)
                  .find(cast => cast.id === selectedOption.id)}
                onDaySelect={(date, name) => {
                  this.setState({
                    selectedDay: date,
                    selectedProperty: name,
                  });
                }}
              />
            )
          )}
        </main>
        <div className="weather-widget__provider">
          <p>{t("tools:weather.provider")}</p>
          <a
            href="https://www.meteo.pl/"
            target="_blank"
            rel="nofollow noopener noreferrer"
          >
            <MeteoLogo />
          </a>
        </div>
      </div>
    );
  }
}

WeatherModalInner.propTypes = {};

export default compose(withTranslation(["tools", "globals"]))(
  withRouter(WeatherModalInner)
);
